import { render } from "./DiscountPanelFilterSection.vue?vue&type=template&id=4ae9f7b5&scoped=true"
import script from "./DiscountPanelFilterSection.vue?vue&type=script&lang=js"
export * from "./DiscountPanelFilterSection.vue?vue&type=script&lang=js"

import "./DiscountPanelFilterSection.vue?vue&type=style&index=0&id=4ae9f7b5&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae9f7b5"]])

export default __exports__